export enum WobGbdType {
  // Undefined				    = "Undefined",
  // Pingsig					    = "Pingsig",

  // Données non stockées en BDD
  // Typiquement données < 1000 = Informations Iris non glider-dependant
  // IrisOpen				    = "IrisOpen",
  // IrisClose				    = "IrisClose",
  // IrisInfoModOpen			= "IrisInfoModOpen",
  // IrisInfoModClose		= "IrisInfoModClose",
  // IrisInfoModMsg			= "IrisInfoModMsg",
  // IrisInfoDebug			  = "IrisInfoDebug",

  // Iris processing background informations
  // IrisProcessingSimuprogress	= 'IrisProcessingSimuprogress',
  // IrisProcessingPathprogress	= 'IrisProcessingPathprogress',
  // IrisProcessingKeepFormation = 'IrisProcessingKeepFormation',
  // IrisProcessingNewPicture	= 'IrisProcessingNewPicture',

  // Iris fleet management
  // IrisFleetStatus				= 'IrisFleetStatus', // Status de la flotte
  // IrisFleetLogbookMessage		= 'IrisFleetLogbookMessage', // Message de logbook de la flotte

  // Données stockées en BDD => table TBL_TRAME_GLIDERMSG_GMS.GMS_TYP
  GliderInfoConnect = 'GliderInfoConnect',
  GliderMessage = 'GliderMessage',
  GliderInfoCmd = 'GliderInfoCmd',
  GliderInfoDownload = 'GliderInfoDownload',

  // A conserver pour utilisation sur les anciens GDB enregistrés en RAW en BDD si besoin
  /// <summary>
  /// Obsolète = ne pas utiliser sauf par compatibilité (sur les anciens GDB enregistrés en RAW en BDD)
  /// </summary>
  //GliderInfofileNew		= "GliderInfofileNew",
  GliderInfofileMulti = 'GliderInfofileMulti',
  GliderInfoHang = 'GliderInfoHang',

  // Données non stockée en BDD car la trame est dans une table hérité en fonction du type (implicite)
  NmeaSeaMrs = 'NmeaSeaMrs',
  NmeaSeaNav = 'NmeaSeaNav',
  NmeaSeaDst = 'NmeaSeaDst',
  NmeaSeaLog = 'NmeaSeaLog',
  NmeaSeaMul = 'NmeaSeaMul',
  NmeaSeaDrf = 'NmeaSeaDrf',
  NmeaSeaBtm = 'NmeaSeaBtm',
  NmeaSeaDev = 'NmeaSeaDev',
  NmeaSeaAlr = 'NmeaSeaAlr',
  NmeaSeaPrf = 'NmeaSeaPrf',
  NmeaSeaSrf = 'NmeaSeaSrf',
  NmeaSeaStp = 'NmeaSeaStp',
  NmeaSeaDrk = 'NmeaSeaDrk',
  NmeaSeaWpt = 'NmeaSeaWpt',
  NmeaSeaFlt = 'NmeaSeaFlt', // 2023-11
  NmeaSeaCom = 'NmeaSeaCom', // 2025-03
  NmeaSeaDrp = 'NmeaSeaDrp', // 2025-03
  NmeaSeaEnc = 'NmeaSeaEnc', // 2026-04

  NmeaPldOut = 'NmeaPldOut',

  // NmeaUnknown				  = "NmeaUnknown",	// Trame reconnue en tant que NMEA mais dont la codification est inconnue => non discrétisée

  // Données volatiles non stockées en BDD car gérées par IRIS et modifiées en dehors d'Aglimms
  GliderInfoModConf = 'GliderInfoModConf',
  GliderInfoModEvent = 'GliderInfoModEvent',
  GliderInfoTarget = 'GliderInfoTarget',

  //Acknowledgement			= "Acknowledgement"
}
